import MuiButton from "../../../components/basicComponent/MuiButton";
import React from "react";

const PaymentSummaryCard = ({ data }: any) => {
  console.log("PaymentSummaryCard data", data);

  // Safely extract values from data
  const roomType = data?.room_type || "N/A";
  const boardType = data?.room_rate_description || "Room Only"; // fallback
  const bookingAmount = data?.chargeable_rate
    ? `${data.currency_code} ${data.chargeable_rate}`
    : "N/A";

  // Nights calculation
  const checkIn = new Date(data?.check_in_date);
  const checkOut = new Date(data?.check_out_date);
  const noOfNights =
    data?.check_in_date && data?.check_out_date
      ? Math.ceil(
          (checkOut.getTime() - checkIn.getTime()) / (1000 * 60 * 60 * 24)
        )
      : 0;

  // Rooms
  const noOfRooms = data?.rooms?.length || 0;

  return (
    <div className="card payment-summary-card shadow-sm mt-1">
      <div className="card-header card-head-bg">Payment Summary</div>
      <div className="card-body">
        <div className="d-flex justify-content-between mb-2">
          <div>Room Type</div>
          <div className="fw-bold">{roomType}</div>
        </div>

        <div className="d-flex justify-content-between mb-2">
          <span>Board Type</span>
          <span className="fw-bold">{boardType}</span>
        </div>

        <div className="d-flex justify-content-between mb-2">
          <span>No. of Nights</span>
          <span className="fw-bold">{noOfNights} Night(s)</span>
        </div>

        <div className="d-flex justify-content-between mb-2">
          <span>No. of Rooms</span>
          <span className="fw-bold">{noOfRooms}</span>
        </div>

        <div className="d-flex justify-content-between mb-2 border-top pt-2 fw-bold text-danger fs-6">
          <span>Booking Amount</span>
          <span>{bookingAmount}</span>
        </div>

        <div className="user-button w-full mt-4">
          <MuiButton
            style={{ width: "100%" }}
            className="clear-btn"
            label="View Invoice"
            type="submit"
          />
        </div>
      </div>
    </div>
  );
};

export default PaymentSummaryCard;
